// Shared display formatters. All dates are shown in Eastern time.

const TIME_ZONE = 'America/New_York';

// The API returns UTC timestamps without a timezone suffix; treat those as UTC
// instead of letting the browser parse them as local time.
export const parseApiDate = (value) => {
    if (value instanceof Date) return value;
    const hasZone = /(Z|[+-]\d{2}:?\d{2})$/i.test(value);
    return new Date(hasZone ? value : value + 'Z');
};

const formatEastern = (value, options) => {
    if (!value) return '-';
    return parseApiDate(value).toLocaleString('en-US', { timeZone: TIME_ZONE, ...options });
};

// 2/26/2026, 3:22 PM
export const formatDateTime = (value) => formatEastern(value, {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
});

// 2/26, 3:22 PM
export const formatShortDateTime = (value) => formatEastern(value, {
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
});

// 3:22 PM
export const formatTime = (value) => formatEastern(value, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
});

// 3:22:05 PM
export const formatClockTime = (value) => formatEastern(value, {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
});

// Thu, Feb 26
export const formatWeekdayDate = (value) => formatEastern(value, {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
});

// 2/26/2026 (also used as a grouping key for per-day charts)
export const formatDay = (value) => formatEastern(value, {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric'
});

// 45s ago, 12m ago, 3h ago, 2d ago
export const formatHeartbeat = (seconds) => {
    if (seconds < 60) return `${seconds}s ago`;
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    return `${Math.floor(seconds / 86400)}d ago`;
};

// 12,345
export const formatNumber = (num) => num?.toLocaleString() || '0';

// 1.50
export const formatMins = (mins) => mins?.toFixed(2) || '0.00';
